module.exports = __webpack_public_path__ + "static/media/markus.df384e58.webp";